var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "workflow-analysis" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "workflow-states" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.workflowAnalisis.estados, function (estado, nombre) {
            return _c(
              "div",
              { key: nombre, staticClass: "col-lg-2 col-md-4 col-sm-6" },
              [
                _c(
                  "div",
                  {
                    staticClass: "workflow-state-card",
                    class: _vm.getStateClass(nombre),
                  },
                  [
                    _c("div", { staticClass: "state-header" }, [
                      _c("div", { staticClass: "state-icon" }, [
                        _c("i", { class: _vm.getStateIcon(nombre) }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "state-name" }, [
                        _vm._v(_vm._s(nombre)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "state-metrics" }, [
                      _c("div", { staticClass: "metric-item" }, [
                        _c("span", { staticClass: "metric-label" }, [
                          _vm._v("Cantidad:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "metric-value" }, [
                          _vm._v(_vm._s(estado.cantidad)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-item" }, [
                        _c("span", { staticClass: "metric-label" }, [
                          _vm._v("Tiempo Promedio:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "metric-value" }, [
                          _vm._v(_vm._s(estado.tiempo_promedio) + "h"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-item" }, [
                        _c("span", { staticClass: "metric-label" }, [
                          _vm._v("Transiciones:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "metric-value" }, [
                          _vm._v(_vm._s(estado.transiciones)),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottlenecks-section" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottlenecks-list" },
          _vm._l(
            _vm.workflowAnalisis.cuellos_botella,
            function (tiempo, etapa) {
              return _c("div", { key: etapa, staticClass: "bottleneck-item" }, [
                _c("div", { staticClass: "bottleneck-stage" }, [
                  _vm._v(_vm._s(etapa)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bottleneck-time" }, [
                  _vm._v(_vm._s(tiempo) + "h"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bottleneck-bar" }, [
                  _c("div", {
                    staticClass: "bottleneck-progress",
                    style: { width: _vm.getBottleneckWidth(tiempo) + "%" },
                  }),
                ]),
              ])
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "efficiency-metrics" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "efficiency-card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "efficiency-content" }, [
                _c("div", { staticClass: "efficiency-value" }, [
                  _vm._v(_vm._s(_vm.workflowAnalisis.tiempo_asignacion) + "h"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "efficiency-label" }, [
                  _vm._v("Tiempo Promedio de Asignación"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "efficiency-card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "efficiency-content" }, [
                _c("div", { staticClass: "efficiency-value" }, [
                  _vm._v(_vm._s(_vm.workflowAnalisis.eficiencia_flujo) + "%"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "efficiency-label" }, [
                  _vm._v("Eficiencia del Flujo"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "efficiency-card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "efficiency-content" }, [
                _c("div", { staticClass: "efficiency-value" }, [
                  _vm._v(_vm._s(_vm.getAutomationOpportunities())),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "efficiency-label" }, [
                  _vm._v("Oportunidades de Automatización"),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "automation-opportunities" }, [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "opportunities-grid" },
          _vm._l(
            _vm.workflowAnalisis.oportunidades_automatizacion,
            function (prioridad, oportunidad) {
              return _c(
                "div",
                {
                  key: oportunidad,
                  staticClass: "opportunity-item",
                  class: _vm.getOpportunityClass(prioridad),
                },
                [
                  _c("div", { staticClass: "opportunity-name" }, [
                    _vm._v(_vm._s(oportunidad)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "opportunity-priority" }, [
                    _vm._v(_vm._s(prioridad)),
                  ]),
                ]
              )
            }
          ),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-project-diagram text-primary" }),
      _vm._v(" Análisis de Workflow"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-exclamation-triangle text-warning" }),
      _vm._v(" Cuellos de Botella Identificados"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "efficiency-icon text-primary" }, [
      _c("i", { staticClass: "fal fa-stopwatch" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "efficiency-icon text-success" }, [
      _c("i", { staticClass: "fal fa-chart-line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "efficiency-icon text-info" }, [
      _c("i", { staticClass: "fal fa-robot" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-lightbulb text-warning" }),
      _vm._v(" Oportunidades de Automatización"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }